export default {
    layout: {
        loading: 'Идёт торговля',
        trading: 'Идёт торговля'
    },
    footer: {
    },
    menu: {
        home: 'Главная',
        staking: 'Матрица',
        port: 'PORT',
        internet: 'Сеть',
        me: 'Профиль'
    },
    header: {
        selectLang: 'Выбрать язык',
        close: 'Закрыть',
        trading: 'Торговля',
        dashboard: 'Панель управления',
        subscribeMatrix: 'Подписка на матрицу',
        portTaskCenter: 'Центр задач PORT',
        network: 'Сеть',
        apiBinding: 'Привязка API',
        gridTree: 'Дерево сетки',
        account: 'Аккаунт',
        documents: 'Документы и Whitepaper',
        personalCenter: 'Личный кабинет',
        language: 'Язык'
    },
    home: {
        recently1:'Сообщество',
        staticrewares: 'Статичный',
        recentlyName: 'Книга учёта',
        recentlyInfo: 'Детали дохода',
        dataUpdate: 'Обновление данных',
        realtime: 'Реальное время · BSC',
        totalRevenue: 'Общий доход (USDT)',
        today: 'Сегодня',
        totalTradingVolume: 'Общий объём торговли',
        todayEarn: 'Сегодня заработано',
        share: 'Поделиться с друзьями',
        shareDesc: 'Покажи доход и пригласи друзей',
        directReferrals: 'Прямые рефералы',
        teamMembers: 'Члены команды',
        thisWeek: 'На этой неделе',
        copy: 'Копировать',
        recently: 'Недавний доход',
        netIncome: 'Чистый доход',
        dailyAverage: 'Среднесуточный',
        quantitativeIncome: 'Квантовый доход',
        recommend: 'Рекомендовать',
        port: 'PORT',
        bonus: 'Бонус',
        all: 'Все',
        todayTitle: 'Сегодня',
        loadingMore: 'Загрузить больше',
        recommendBonus: 'Реферальный бонус',
        portTaskPassed: 'Задача PORT выполнена',
        myProfit: 'Моя прибыль',
        earningOnBitDeep: 'Я зарабатываю на BitDeep',
        totalRevenueUsdt: 'Общий доход · USDT',
        consecutiveDays: 'Подряд дней',
        scanToJoin: 'Сканируй для участия',
        uid: 'UID',
        referralBonus: 'Реферальный бонус',
        shareTo: 'Поделиться в',
        eachReferral: 'Бонус за приглашение',
        screenshotAndShare: 'Сделай скриншот и поделись',
        saveShareEarn: 'Сохрани · Поделись · Заработай',
        period: 'Период',
        netProfit: 'Чистая прибыль',
        quantReward: 'Квантовый бонус',
        dailyBonus: 'Ежедневный бонус PORT',
        close: 'Закрыть',
        permission: 'Разрешение',
        onlyEnable: 'Только включить',
        enterBitgetUid: 'Введите BITGET UID',
        slogan: 'Слоган',
        document: 'Документ',
        days: 'Дни',
        taskText: 'Задача',
        minutes: 'Минуты',
        decentralizedPortTech: 'Децентрализованная архитектура PoRT, экономика токена BGB и двойная матрица стимулов.',
        auditReport: 'Аудиторский отчёт',
        faqSupport: 'FAQ и поддержка',
        telegram: 'Telegram',
        piece: 'Часть',
        faq: 'FAQ',
       faq1: 'Как привязать Bitget API?',
        faq1Desc: 'Перейдите в Bitget Exchange → Настройки → Управление API и получите API Key и Secret. В правах включайте только спот-торговлю; категорически запрещено включать вывод средств. Вставьте ключи в BitDeep DApp. После завершения тестовой сделки на 1 USDT привязка активируется.',
        faq2: 'Что такое PoRT (доказательство реальной торговли)?',
        faq2Desc: 'PoRT — основной механизм концепции «торговля = майнинг». Каждый день система через Bitget API автоматически выполняет быстрые сделки на указанной монете (например, BGB). Когда объём превышает Stake × 50%, после проверки начисляется дневная награда.',
        faq3: 'Нужно ли ежедневно следить за рынком вручную?',
        faq3Desc: 'Нет. После привязки API система автоматически выполняет торговые задачи в течение 24-часового окна. Ручные действия не требуются; прогресс можно проверить в меню PoRT.',
        faq4: 'В чём разница между ALPHA и SIGMA?',
        faq4Desc: 'ALPHA (Стартовый): стейк 500 USDT, доходность 0.3–1.3% в день, не более 1 пакета. SIGMA (Профи): стейк 1 000 USDT, доходность 0.6–1.6% в день, до 5 пакетов.',
        faq5: 'Безопасны ли мои средства? Может ли платформа распоряжаться моими деньгами?',
        faq5Desc: 'Ваши средства на 100% остаются на вашем счёте Bitget. API даёт только разрешения на чтение и спот-торговлю; система не может вывести или перевести основной капитал.',
        faq6: 'Когда производится расчёт ежедневного дохода?',
        faq6Desc: 'После успешной проверки PoRT расчёт происходит на следующий день. Система автоматически выпускает двойную награду — доход в USDT и баллы 10x Deep.',
        faq7: 'Как рассчитывается Scout Bonus (награда за прямого реферала)?',
        faq7Desc: 'За каждый активный аккаунт, приглашённый напрямую, вы получаете фиксированную ежедневную награду: 1 USDT/день за реферала ALPHA (500 USDT), 2 USDT/день за реферала SIGMA (1 000 USDT). Выплаты идут до окончания цикла этого аккаунта.',
        faq8: 'Как повышаются уровни (D1–D7)?',
        faq8Desc: 'Уровни повышаются по объёму малой стороны (small-leg). Например: D1 — 2 000 USDT, D3 — 15 000 USDT, максимальный D7 — 3 000 000 USDT. Чем выше уровень, тем больше дифференциальная награда (до 7 USDT/чел./день на D7).',
        faq9: 'Сколько дней длится один цикл? Что происходит по его окончании?',
        faq9Desc: 'Один цикл — 28 дней. По окончании цикла можно продолжить стейкинг; награды выплачиваются в зависимости от фактических ежедневных результатов проверки PoRT (плавающая доходность).',
        faq10: 'Есть ли комиссия за вывод?',
        faq10Desc:'Комиссия за вывод — 0. Платформа возвращает все комиссии в пул для увеличения LP-ликвидности, создавая положительный цикл.',
        bigArea: 'Большая зона',
        smallArea: 'Малая зона',
        enterWithdrawAmount: 'Введите сумму вывода',
        all: 'Все',
        available: 'Доступно',
        totalAmount: 'Общая сумма',
        confirmWithdraw: 'Подтвердить вывод',
        withdrawRecord: 'История вывода',
        withdrawn: 'Выведено',
        quickStartGuide:'Быстрый старт',
        whitepaperGuide:'Whitepaper и руководство',
        whitepaper:'Whitepaper',
        downloadPdf:'Скачать'
    },
    staking: {
        selectPackage: 'Подписка на матрицу',
        alpha: 'ALPHA',
        beginner: 'Новичок',
        sigma: 'SIGMA',
        professional: 'Профессионал',
        popular: 'Самый популярный',
        dailyReturn: 'Ежедневная доходность',
        teamDepth: 'Глубина команды',
        limitPurchase: 'Ограничение покупки',
        layer: 'Уровень',
        copy: 'Часть',
        autoRenew: 'Автопродление',
        autoReinvest: 'Автоматическое реинвестирование',
        subscribeAlpha: 'Подписка Alpha',
        subscribeSigma: 'Подписка Sigma',
        stakedAmount: 'Сумма стейкинга',
        stakedAmount2: 'Период',
        stakedAmount3: 'Накопленный доход',
        stakingTime: 'Время стейкинга',
        maturityTime: 'Время окончания',
        redeem: 'Выкупить',
        renew: 'Продлить',
        autoRenewActive: 'Автопродление включено',
        autoRenewInactive: 'Автопродление выключено',
        smartContract: 'Управление смарт-контрактом, средства блокируются на 28 дней и разблокируются по окончании.'
    },
    me: {
    account: 'Аккаунт',
    my: 'Мой',
    staked: 'Застейкано',
    points: 'Баллы',
    consecutive: 'Подряд дней',
    withdraw: 'Вывод',
    language: 'Язык',
    simplifiedChinese: 'Упрощённый китайский',
    disconnectWallet: 'Отключить кошелёк',
    level: 'Уровень',
    joinDate: 'Дата присоединения',
    bdId: 'BD-ID'
},
bindapi: {
    apiBinding: 'Привязка API',
    bindDesc: 'Привяжите API ключи биржи для авторизации квантовой торговли',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    exchange: 'Биржа',
    futures: 'Фьючерсы',
    spot: 'Спот',
    readOnly: 'Только чтение',
    bind: 'Привязать',
    riskNote: 'API ключ используется только для синхронизации данных торговли, чувствительная информация не хранится',
    apiConnection: 'API соединение',
    bindExchangeApi: 'Привязать API биржи',
    bitDeepRead: 'BitDeep считывает поток ордеров вашего CEX аккаунта для проверки реальной торговли (PoRT).',
    noWithdraw: 'Мы никогда не касаемся ваших выводов.',
    securityTip: 'Совет по безопасности · внимательно прочитайте',
    close: 'Закрыть',
    withdraw: 'Вывод',
    permission: 'Разрешение',
    onlyEnable: 'Только включить',
    spotTrading: 'Спотовая торговля',
    read: 'Чтение',
    recommendedPartner: 'Рекомендуемый партнёр',
    zeroFee: '0% комиссия',
    activated: 'Активировано',
    classicAccount: 'Классический аккаунт',
    unifiedAccount: 'Унифицированный аккаунт',
    bindBitgetApi: 'Привязать Bitget API',
    upcoming: 'Скоро',
    underAudit: 'На аудите',
    expected: 'Ожидается'
},
port: {
    portTaskCenter: 'Центр задач PORT',
    dailyTask: 'Ежедневная задача',
    verify: 'Проверить',
    completed: 'Завершено',
    incomplete: 'Не завершено',
    verifyStandard: 'Стандарт проверки',
    tradingVolume: 'Объём торговли',
    today: 'Сегодня',
    deadline: 'Крайний срок',
    reward: 'Награда',
    startVerify: 'Начать проверку',
    verifying: 'Проверка',
    verified: 'Проверено',
    insufficient: 'Недостаточно',
    viewDetails: 'Посмотреть детали',
    taskList: 'Список задач',
    allTasks: 'Все задачи',
    completedTasks: 'Завершено',
    pendingTasks: 'В ожидании',
    proofOfRealTrading: 'Доказательство реальной торговли',
    todayTask: 'Задача на сегодня',
    todayStaticIncome: 'Сегодня статичный доход',
    points: 'Баллы',
    todayWindowClosesAt: 'Окно сегодня закрывается в',
    checkTaskStatus: 'Проверить статус задачи',
    teamProgress: 'Прогресс команды · сегодня',
    realtimePortCompletion: 'Реальное время выполнения PORT',
    completedText: 'Завершено',
    pendingText: 'В ожидании',
    realtimeApiValidationFlow: 'Реальное время · API · поток проверки',
    rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
},
internet: {
    network: 'Сеть',
    treeBrowser: 'Древовидный браузер',
    searchAddress: 'Поиск адреса 0x... или BD-ID',
    totalTradingVolume: 'Общий объём торговли',
    members: 'Участники',
    networkStructure: 'Структура сети',
    allLevels: 'Все уровни',
    addRemark: 'Добавить заметку',
    enterRemark: 'Введите заметку',
    cancel: 'Отмена',
    confirm: 'Подтвердить'
},
withdraw: {
    withdraw: 'Вывод',
    usdtAsset: 'Актив USDT',
    withdrawAmount: 'Сумма вывода',
    availableBalance: 'Доступный баланс',
    fee: 'Комиссия',
    actualArrival: 'Фактическое поступление',
    submit: 'Отправить',
    withdrawSuccess: 'Вывод успешен',
    withdrawFailed: 'Вывод не удался',
    processing: 'В обработке',
    completed: 'Завершено',
    withdrawHistory: 'История вывода'
},
popup: {
    taskUnfinished: 'Задача не завершена',
    taskUnfinishedDesc: 'Данные торговли не достигли стандарта проверки PoRT сегодня',
    todayTradingVolume: 'Сегодня объём торговли',
    remaining: 'Осталось',
    toComplete: 'для завершения задачи',
    tradingVolumeThreshold: '',
    deadline: 'До конца задачи осталось',
    tryAgain: 'Попробовать позже',
    goTrade: 'Перейти к торговле',
    taskCompleted: 'Задача проверена',
    taskCompletedDesc: 'Доказательство торговли PoRT сегодня успешно записано в блокчейн',
    rewardIssued: 'Награда выдана',
    complete: 'Завершено',
    shareTitle: 'Приглашение поделиться',
    shareDesc: 'Пригласите друзей зарегистрироваться, обе стороны получат награды',
    referralLink: 'Реферальная ссылка',
    qrCode: 'QR-код',
    copyLink: 'Скопировать ссылку'
}

};
